import StatCard from "./StatCard";

/**
 * Renders a responsive grid of StatCards from a `cards` array.
 * `cards = [{ testid, label, value, hint?, tone? }, ...]`.
 */
export default function SummaryCards({ cards, testid = "summary-cards" }) {
  return (
    <div
      data-testid={testid}
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3"
    >
      {cards.map((c) => (
        <StatCard key={c.testid} {...c} />
      ))}
    </div>
  );
}
